import { useSearchParams } from "react-router-dom";
import { SessionReplayViewer } from "@deep-consulting-solutions/session-recording-s3";
import { usersService } from "../../services/admin/users.service";
import DeepLinkSessionPlayer from "../../components/admin/DeepLinkSessionPlayer";

async function handleSearchUsers(query: string) {
  const users = await usersService.getActive();
  const q = query.toLowerCase();
  return users
    .filter(
      (u) =>
        u.full_name?.toLowerCase().includes(q) ||
        u.username?.toLowerCase().includes(q)
    )
    .map((u) => ({
      id: u.id,
      email: u.username,
      name: u.full_name || u.username,
    }));
}

export default function SessionRecordingsPage() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("sessionId");
  const userId = searchParams.get("userId");
  const date = searchParams.get("date");

  const isDeepLink = sessionId && userId && date;

  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      {isDeepLink ? (
        <DeepLinkSessionPlayer
          sessionId={sessionId}
          userId={userId}
          date={date}
        />
      ) : (
        <SessionReplayViewer
          onSearchUsers={handleSearchUsers}
          style={{ flex: 1 }}
        />
      )}
    </div>
  );
}
